import styles from './styles.module.css';
import { Select, SelectItem } from '@plone/components';
import '@plone/components/src/styles/basic/Select.css';
import '@redturtle/qubicaamf-theme/components/Header/customSelect.css';

import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  qubica_locale_selector_title: {
    id: 'qubica_locale_selector_title',
    defaultMessage: 'QubicaAMF Local Websites',
  },
});

const locale_sites = [
  {
    id: 'ca',
    href: 'https://ca.qubicaamf.com/',
    title: 'QubicaAMF Canada',
  },
  {
    id: 'fr',
    href: 'https://fr.qubicaamf.com',
    title: 'QubicaAMF France',
  },
  {
    id: 'it',
    href: 'https://it.qubicaamf.com',
    title: 'QubicaAMF Italy',
  },
  {
    id: 'la',
    href: 'https://la.qubicaamf.com',
    title: 'QubicaAMF Latinamerica',
  },
  {
    id: 'uk',
    href: 'https://uk.qubicaamf.com',
    title: 'QubicaAMF UK',
  },
  {
    id: 'other',
    href: '/contact/find-your-local-representative',
    title: 'Other',
  },
];

export default function LocalWebSiteMenu() {
  const intl = useIntl();
  return (
    <Select
      placeholder={intl.formatMessage(messages.qubica_locale_selector_title)}
      className={styles.qubica_locale_selector}
    >
      <>
        {locale_sites.map((site) => (
          <SelectItem key={site.id} className={styles.selector_item}>
            <a href={site.href}>{site.title}</a>
          </SelectItem>
        ))}
      </>
    </Select>
  );
}
